    $('.tego-files-upload').filesUpload();
    $('form.submit-disabled-if-upload')
        .on('filesUploadBefore', function () {
            $(this).find(':submit').attr('disabled', 'disabled');
        })
        .on('filesUploadAfter', function () {
            if ($(this).find('.files-upload-en-cours').length===0) {
                $(this).find(':submit').removeAttr('disabled');
            }
        });
